<div class="recommendations-box">
  <div class="recommendations-box__container">
    <div class="recommendations-box__content">
      <div class="recommendations-box__text">
        <div class="recommendations-box__header">
          <div class="recommendations-box__title">
            {{ 'app.components.courseCreator.settings.recommendationsBox.title' | translate }}
          </div>
        </div>
        <div class="recommendations-box__description">
          {{ 'app.components.courseCreator.settings.recommendationsBox.description' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
